'use client';
import { useEffect } from 'react';
/**
 * ТРИГГЕР УШЁЛ ИЗ ВИДИМОЙ ОБЛАСТИ - ПАНЕЛЬ ЗАКРЫВАЕТСЯ.
 *
 * Правило продукта, а не библиотеки. Панель живёт порталом и положением
 * `fixed`: прокрутив колонку, человек уводит кнопку, а панель остаётся
 * висеть посреди экрана - список, относящийся неизвестно к чему.
 *
 * Radix умеет прятать оторвавшуюся панель (`hideWhenDetached`), но именно
 * прятать: узел остаётся в разметке, состояние остаётся открытым, и
 * следующее нажатие возвращает панель на пустое место. Нам нужно закрытие.
 *
 * Своих строк здесь ровно столько, сколько нужно: наблюдатель пересечения на
 * кнопке, и закрытие, когда она перестала быть видимой.
 */
export function useCloseWhenTriggerHidden(trigger, open, close) {
    useEffect(() => {
        const node = trigger.current;
        if (!open || node === null)
            return undefined;
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                /* Половина кнопки за краем - это уже «ушла»: панель, привязанная к
                   наполовину срезанному триггеру, читается как висящая сама по
                   себе. */
                if (entry.intersectionRatio < 0.5)
                    close();
            }
        }, { threshold: [0, 0.5, 1] });
        observer.observe(node);
        return () => {
            observer.disconnect();
        };
    }, [trigger, open, close]);
}
//# sourceMappingURL=useTriggerVisible.js.map